import { Image } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: center;
  width: 90%;
  max-width: 1010px;
  column-gap: 16px;

  @media screen and (max-width: 2560px) {
    display: inline-flex;
  }
  @media only screen and (max-width: 768px) {
    ${(props) =>
      props?.dark ? "overflow-x: auto; justify-content: flex-start;" : ""}
  }
  @include medium {
    overflow: hidden;
    width: 700px;
  }
  @include small {
    overflow: hidden;
    width: auto;
    overflow: hidden;
    justify-content: flex-start;
  }
  @media only screen and (min-width: 769px) {
    width: 100%;
    column-gap: ${(props) => (props?.dark ? "16px" : "24px")};
    margin-top: 24px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: ${(props) => (props?.dark ? "center" : "flex-start")};
  border-radius: ${(props) => (props?.dark ? "24px" : "16px")};
  background-color: ${(props) =>
    props?.isActive
      ? (props?.activeBgColor ?? "#fff")
      : props?.dark
        ? "#233750"
        : "#fff"};
  width: ${(props) => props?.width};
  flex-shrink: ${(props) => (props?.dark ? 0 : 1)};
  border: ${(props) =>
    props?.dark ? "1.5px solid #0397C9" : "1px solid #f0f2f9"};
  @media only screen and (min-width: 769px) {
    padding: ${(props) => (props?.dark ? "18px" : "12px")};
    cursor: pointer;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => (props?.dark ? "12px" : "16px")};
  row-gap: 8px;
`;

export const CardTitle = styled.h1`
  font-size: 13px;
  color: ${(props) =>
    props?.isActive ? "#fff" : props?.dark ? "#fff" : "#6A7481"};
  margin: 0;
  padding: 0 !important;
  line-height: unset;
  font-weight: 700;
  ${(props) => (props?.dark ? "white-space: nowrap;" : "")}

  @media only screen and (min-width: 769px) {
    font-size: ${(props) =>
      props?.dark ? props?.titleSize || "21px" : "28px"};
    line-height: ${(props) => (props?.dark ? "29px" : "37px")};
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-radius: 50%;
  width: 41px;
  height: 41px;
  background-color: ${(props) =>
    props?.isActive
      ? (props?.iconActiveBgColor ?? "#fff")
      : props?.dark
        ? "#33475F"
        : "#F0F2F9"};
  overflow: hidden;

  @media only screen and (min-width: 769px) {
    width: ${(props) => (props?.dark ? "60px" : "80px")};
    height: ${(props) => (props?.dark ? "60px" : "80px")};
  }
`;

export const CardImage = styled(Image)`
  position: relative;
  width: 36px;
  height: 36px;

  @media only screen and (min-width: 769px) {
    width: ${(props) => (props?.$dark ? "51px" : "68px")};
    height: ${(props) => (props?.$dark ? "51px" : "68px")};
  }
`;

export const CardItemContainer = styled.div``;
